import React from 'react'
import { REPORT_TEXT } from 'shared-ui/utils/constants'
import {
  BlurOverlay,
  BlurContent,
  ShowContent,
  BlurImageTitle,
  BlurImageDescription
} from './style.jsx'
import { ReportUserIcon } from 'shared-ui/assets'
import { useResponsive } from 'shared-ui/hooks'
import { media } from 'shared-ui/utils/media'

function BlurImage({ handleShowContent }) {
  const isMobile = useResponsive(media.mobile)

  return (
    <BlurOverlay onClick={(e) => e.stopPropagation()}>
      <BlurContent isMobile={isMobile}>
        <ReportUserIcon />
        <BlurImageTitle className="mt-4 mb-2">
          {REPORT_TEXT.REPORTED_CONTENT_TITLE}
        </BlurImageTitle>
        <BlurImageDescription>
          {REPORT_TEXT.REPORTED_CONTENT_DESCRIPTION}
        </BlurImageDescription>
        <ShowContent
          isMobile={isMobile}
          className="mt-4"
          onClick={(e) => {
            e.stopPropagation()
            handleShowContent()
          }}
        >
          {REPORT_TEXT.SHOW_CONTENT}
        </ShowContent>
      </BlurContent>
    </BlurOverlay>
  )
}

export default BlurImage
